import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { CommentForm, FloatingContainer } from '@contently/toolkit';
import useOutsideClick from '../../hooks/useOutsideClick';
import useStoryContext from '../../hooks/useStoryContext';

export default function FloatingCommentForm({
  yPos,
  handleSubmitComment,
  handleCancelComment,
  users
}) {
  const formRef = useRef(null);

  // Only set up the outside click handler if handleCancelComment is a function
  if (typeof handleCancelComment === 'function') {
    useOutsideClick(formRef, handleCancelComment);
  } else {
    console.warn('handleCancelComment is not a function in FloatingCommentForm');
  }

  return (
    <div ref={formRef} className="floating-container-wrapper">
      <FloatingContainer right={-372} top={yPos}>
        <CommentForm onSubmit={handleSubmitComment} onCancel={handleCancelComment} users={users} />
      </FloatingContainer>
    </div>
  );
}

FloatingCommentForm.propTypes = {
  yPos: PropTypes.number.isRequired,
  handleSubmitComment: PropTypes.func.isRequired,
  handleCancelComment: PropTypes.func.isRequired,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      display: PropTypes.string
    })
  )
};

FloatingCommentForm.defaultProps = {
  users: []
};



// WEBPACK FOOTER //
// ./app/javascript/client/components/textEditor/FloatingCommentForm.jsx